import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=28f50c01&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=28f50c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f50c01",
  null
  
)

export default component.exports